import { heroEquipment } from "../HeroEquipment";

export const cyrkowcy = {
  heroes: {
    Mecenas: {
      id: 0,
      startingEquipment: ["Sztylet", "Miecz"],
      cost: 55,
      number: 1,
      equipmentList: heroEquipment["Cyrkowcy z Ligii Ostermarku"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 4, 3, 3, 2, 4, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Dowódca"],
      exp: 20,
      skills: [0, 1, 2, 3, 4, 5],
    },
    "Magister Magii": {
      id: 1,
      startingEquipment: ["Sztylet", "Kostur"],
      cost: 35,
      number: 1,
      equipmentList:
        heroEquipment["Cyrkowcy z Ligii Ostermarku"]["Magister magii"],
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Mag (Tradycja Cienia)"],
      exp: 12,
      skills: [0, 2, 4, 5],
    },
    "Kapłan Ranalda": {
      id: 2,
      startingEquipment: ["Sztylet", "Kostur"],
      cost: 35,
      number: 1,
      equipmentList:
        heroEquipment["Cyrkowcy z Ligii Ostermarku"]["Kapłan Ranalda"],
      type: "Bohater",
      stats: {
        Początkowa: [4, 2, 2, 3, 3, 1, 4, 1, 8],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Duchowny (modlitwy do Ranalda)","Gadanina","Modlitwa","Rewelator","Rozproszenie magii (2)","Wzgardzony"],
      exp: 12,
      skills: [0, 2, 4, 5],
    },
    Szarlatan: {
      id: 3,
      startingEquipment: ["Sztylet", "Miecz"],
      cost: 25,
      number: 2,
      equipmentList: heroEquipment["Cyrkowcy z Ligii Ostermarku"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Gadanina"],
      exp: 8,
      skills: [0, 1, 4, 5],
    },
    Treser: {
      id: 4,
      startingEquipment: ["Sztylet", "Łapacz"],
      cost: 25,
      number: 1,
      equipmentList: heroEquipment["Cyrkowcy z Ligii Ostermarku"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Treser"],
      exp: 8,
      skills: [0, 3, 4, 5],
    },
    Cyrkowiec: {
      id: 5,
      startingEquipment: ["Sztylet"],
      cost: 20,
      number: 7,
      equipmentList: heroEquipment["Cyrkowcy z Ligii Ostermarku"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: [
        "Akrobata",
        "Chorążowie & sygnaliści",
        "Drużyna obsługi",
        "Wspinaczka",
      ],
    },
    Siłacz: {
      id: 6,
      startingEquipment: ["Sztylet", "Miecz"],
      cost: 35,
      number: 3,
      equipmentList: heroEquipment["Cyrkowcy z Ligii Ostermarku"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 4, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Akrobata", "Siłacz", "Wspinaczka"],
    },
    Żongler: {
      id: 7,
      startingEquipment: ["Sztylet", "Broń miotana (noże)"],
      cost: 35,
      number: 3,
      equipmentList: heroEquipment["Cyrkowcy z Ligii Ostermarku"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 4, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
      },
      rules: ["Akrobata", "Nożownik", "Wspinaczka"],
    },
    Woltyżer: {
      id: 8,
      startingEquipment: [
        "Sztylet",
        "Miecz",
        "Łuk",
        "Koń bojowy",
        "Siodło & uprząż",
      ],
      cost: 70,
      number: 3,
      equipmentList: heroEquipment["Cyrkowcy z Ligii Ostermarku"].Stronnicy,
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 3, 1, 3, 1, 7],
        Maksymalna: [5, 6, 6, 4, 4, 3, 6, 4, 9],
        "Koń bojowy": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: [
        "Akrobata",
        "Kawalerzysta",
        "Lekka jazda",
        "Pewny strzał",
        "Wspinaczka",
      ],
    },
    Szablozębny: {
      id: 9,
      startingEquipment: ["Broń naturalna (precyzyjne uderzenie)"],
      cost: 70,
      number: 2,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [8, 4, 0, 4, 4, 2, 4, 2, 4],
        Maksymalna: [8, 4, 0, 4, 4, 2, 4, 2, 4],
      },
      rules: [
        "Duży cel",
        "Głód krwi",
        "Nienawiść",
        "Rączy",
        "Strach",
        "Zwiadowca",
        "Zwierzę",
      ],
    },
    Ogr: {
      id: 10,
      startingEquipment: ["Maczuga ogrów"],
      cost: 160,
      number: 1,
      equipmentList: heroEquipment["Cyrkowcy z Ligii Ostermarku"].Ogr,
      type: "Stronnik",
      stats: {
        Początkowa: [6, 3, 2, 4, 4, 3, 2, 2, 7],
        Maksymalna: [6, 6, 5, 5, 5, 5, 6, 5, 9],
      },
      rules: [
        "Bycza szarża",
        "Duży cel",
        "Głód trzewi",
        "Oznakowany gnoblar (gnoblar-uwaga)",
        "Przepastne trzewia",
        "Strach",
        "Tempy",
        "Wielkolud",
      ],
    },
    Niedźwiedź: {
      id: 11,
      startingEquipment: ["Broń naturalna"],
      cost: 125,
      number: 1,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [6, 4, 0, 5, 4, 3, 4, 3, 6],
        Maksymalna: [6, 4, 0, 5, 4, 3, 4, 3, 6],
      },
      rules: ["Bestia", "Głód trzewi", "Potwór", "Zwiadowca", "Zwierzę"],
    },
    Zaprzęg: {
      id: 12,
      startingEquipment: [],
      cost: 175,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Powóz: ["-", "-", "-", 4, 8, 8, "-", "-", "-"],
        Koń: [8, 3, 0, 3, "-", "-", 3, 1, 5],
        "Koń ": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: ["Duży cel", "Kontakty handlowe (3)", "Machina wojenna", "Powóz"],
    },
    Rydwan: {
      id: 13,
      startingEquipment: [],
      cost: 125,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Rydwan: ["-", "-", "-", 5, 5, 8, "-", "-", "-"],
        Koń: [8, 3, 0, 3, "-", "-", 3, 1, 5],
        "Koń ": [8, 3, 0, 3, "-", "-", 3, 1, 5],
      },
      rules: ["Duży cel", "Machina wojenna", "Rydwan"],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 15,
  name: "Cyrkowcy z Ligii Ostermarku",
  nature: "Neutralna",
  armyRules: ["Kontakty handlowe (3)", "Rozrzutność"],
  mercenaries: [
    "Balistyk",
    "Bombardier",
    "Czarownica",
    "Gladiator",
    "Goniec",
    "Kartograf",
    "Kupiec",
    "Latarnik",
    "Łowca nagród",
    "Magus",
    "Medyk",
    "Minstrel",
    "Miotacz ołowiu",
    "Ochroniarz",
    "Pogromca Trolli",
    "Poszukiwacz złota",
    "Rozbójnik",
    "Rycerz najemny",
    "Skryba",
    "Strażnik dróg",
    "Szczurołap",
    "Szpieg",
    "Tileański kusznik",
    "Trefniś",
    "Woźnica",
    "Wróżbita",
    "Złodziej",
    "Zwadźca",
    "Zwiadowca",
  ],
};
